export default __webpack_public_path__ + "static/media/fox-affiliate-text.2b551969.png";